export const headerMainTranslationKeys = {
  balanceAvailable: 'balance.available',
  paymentsNextPayment: 'payments.next-payment',
}
